import { TFunction } from 'next-i18next'
import React from 'react'
import styles from '../../styles/pages/our-solution.module.scss';
import { Grid } from '@mui/material';

const SkillsLibrary = (props: Props) => {
  const { t } = props;
  
  return (
    <section className="fullWidthBG">
      <div className="fullWidthInner">

      <h2 style={{ padding: '20px 15px 15px 5px' }}>{t('skills-library-h2')}</h2>
      <p>{t('skills-library-p1')} {t('skills-library-p2')}</p>

      <Grid container spacing={6} className={styles.skillsLibrarySection}>
        <Grid item xs={12} sm={4} className={styles.skillsLibraryItem}>
          <h3 className={styles.skillsLibraryHeader} style={{ backgroundColor: '#36A852'}}>{t('hard-skills-h3')}</h3>
          <ul className={styles.skillsLibraryContent}>
            <li>{t('hard-skills-row1')}</li>
            <li>{t('hard-skills-row2')}</li>
            <li>{t('hard-skills-row3')}</li>
          </ul>
        </Grid>
        <Grid item xs={12} sm={4} className={styles.skillsLibraryItem}>
          <h3 className={styles.skillsLibraryHeader} style={{ backgroundColor: '#EA4535'}}>{t('life-skills-h3')}</h3>
          <ul className={styles.skillsLibraryContent}>
            <li>{t('life-skills-row1')}</li>
            <li>{t('life-skills-row2')}</li>
            <li>{t('life-skills-row3')}</li>
            <li>{t('life-skills-row4')}</li>
            <li>{t('life-skills-row5')}</li>
            <li>{t('life-skills-row6')}</li>
            <li>{t('life-skills-row7')}</li>
            <li>{t('life-skills-row8')}</li>
          </ul>
        </Grid>
        <Grid item xs={12} sm={4} className={styles.skillsLibraryItem}>
          <h3 className={styles.skillsLibraryHeader} style={{ backgroundColor: '#557EBF'}}>{t('professional-skills-h3')}</h3>
          <ul className={styles.skillsLibraryContent}>
            <li>{t('professional-skills-row1')}</li>
            <li>{t('professional-skills-row2')}</li>
            <li>{t('professional-skills-row3')}</li>
            <li>{t('professional-skills-row4')}</li>
            <li>{t('professional-skills-row5')}</li>
            <li>{t('professional-skills-row6')}</li>
          </ul>
        </Grid>
      </Grid>
      
      </div>
    </section>
  )
}

interface Props {
  t: TFunction
}

export default SkillsLibrary
